import React, { useRef, useState } from "react";
import AnimateFromBottom from "../../LandingPage/component/AnimateFromBottom";
import language from "../../../helpers/language";
import howItWorkImg from "../../../assets/landing-page/how-it-work.png";

const HowItWorks = () => {
  const [lang] = useState(language.getLang());
  const [activeStep, setActiveStep] = useState(0);
  const mobileScrollRef = useRef(null);

  const steps = [
    { number: "01", title: lang?.howItWorks_step1_title, desc: lang?.howItWorks_step1_desc },
    { number: "02", title: lang?.howItWorks_step2_title, desc: lang?.howItWorks_step2_desc },
    { number: "03", title: lang?.howItWorks_step3_title, desc: lang?.howItWorks_step3_desc },
  ];

  const renderStepCard = ({ number, title, desc }) => (
    <div className="how--create--card bg-white border border-gray-200 rounded-md shadow-sm md:px-8 px-3 py-7 text-center h-full" style={{ minHeight: "165px" }}>
      <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-5">
        <span className="text-green-accent font-bold text-base">{number}</span>
      </div>
      <h4 className="text-gray-900 font-bold text-sm md:text-sm mb-3 leading-tight">
        {title}
      </h4>
      <p className="text-gray-500 leading-snug">{desc}</p>
    </div>
  );

  const handleMobileScroll = () => {
    const container = mobileScrollRef.current;

    if (!container) {
      return;
    }

    const cards = Array.from(container.children);
    const nextActiveStep = cards.reduce((closestIndex, card, index) => {
      const currentDistance = Math.abs(card.offsetLeft - container.scrollLeft);
      const closestDistance = Math.abs(cards[closestIndex].offsetLeft - container.scrollLeft);

      return currentDistance < closestDistance ? index : closestIndex;
    }, 0);

    setActiveStep(nextActiveStep);
  };

  const scrollToStep = (index) => {
    const container = mobileScrollRef.current;
    const card = container?.children[index];

    if (!container || !card) {
      return;
    }

    container.scrollTo({
      left: card.offsetLeft,
      behavior: "smooth",
    });
    setActiveStep(index);
  };

  return (
    <section className="relative md:px-14 px-4 md:py-10 py-6 overflow-hidden">
      <img
        src={howItWorkImg}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="relative max-w-6xl mx-auto">
        <div
          className="relative z-10"
        >
          <div className="">
          {/* Pill */}
          <AnimateFromBottom delay={0.1}>
            <div className="flex justify-center mb-6">
              <span className="inline-block bg-blue-400 text-white text-xs font-semibold px-10 py-2 rounded">
                {lang?.howItWorks_pill}
              </span>
            </div>
          </AnimateFromBottom>

          {/* Heading */}
          <AnimateFromBottom delay={0.2}>
            <h2 className="text-center text-gray-900 font-extrabold text-3xl md:text-5xl">
              {lang?.howItWorks_title}
            </h2>
          </AnimateFromBottom>
          </div>

          {/* Step cards */}
          <div
            ref={mobileScrollRef}
            onScroll={handleMobileScroll}
            className="how-it-works-card-scroll flex md:hidden gap-5 mt-12 overflow-x-scroll overflow-y-hidden pb-3"
          >
            {steps.map((step) => (
              <div className="how-it-works-card-item" key={step.number}>
                {renderStepCard(step)}
              </div>
            ))}
          </div>
          <div className="md:hidden flex items-center justify-center gap-2 mt-3" aria-label="How it works slides">
            {steps.map((step, index) => (
              <button
                key={step.number}
                type="button"
                onClick={() => scrollToStep(index)}
                className={`h-2 rounded-full transition-all duration-200 ${
                  activeStep === index ? "w-6 bg-green-accent" : "w-2 bg-gray-300"
                }`}
                aria-label={`Show step ${index + 1}`}
                aria-current={activeStep === index ? "true" : undefined}
              />
            ))}
          </div>

          <div className="hidden md:grid md:grid-cols-3 gap-5 mt-12 md:overflow-visible md:pb-0">
            {steps.map(({ number, title, desc }, i) => (
              <AnimateFromBottom delay={0.3 + i * 0.1} key={number}>
                {renderStepCard({ number, title, desc })}
              </AnimateFromBottom>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
